import React from 'react';
import PropTypes from 'prop-types';

const PaymentStatus = ({ status }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 0:
        return 'fa-plus-square';
      case 1:
        return 'fa-check-square';
      case 2:
        return 'fa-check-square';
      case 3:
        return 'fa-times-circle';
      default:
        return 'fa-question-circle';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return 'text-info';
      case 1:
        return 'text-warning';
      case 2:
        return 'text-success';
      case 3:
        return 'text-danger';
      default:
        return 'text-secondary';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 0:
        return 'New, awaiting payment';
      case 1:
        return 'Paid, awaiting service activation';
      case 2:
        return 'Completed, service activated';
      case 3:
        return 'Canceled, payment not completed';
      default:
        return 'Unknown';
    }
  };

  const statusIcon = getStatusIcon(status);
  const statusColor = getStatusColor(status);
  const statusText = getStatusText(status);

  return (
    <span title={statusText}>
      <i className={`fa ${statusIcon} ${statusColor}`}></i>
    </span>
  );
};

PaymentStatus.propTypes = {
  status: PropTypes.number.isRequired,
};

export default PaymentStatus;
